package com.xtream.data_kmp.db.repo

import androidx.paging.Pager
import androidx.paging.PagingConfig
import androidx.paging.PagingData
import androidx.paging.PagingSource
import androidx.room3.Transaction
import com.xtream.data_kmp.AllConst
import com.xtream.data_kmp.AllConst.PAGING_PAGE_SIZE
import com.xtream.data_kmp.db.dao.BaseRoomStreamsInterface
import com.xtream.data_kmp.db.dao.RoomBaseInterface
import kotlinx.coroutines.flow.Flow


abstract class  LocalStreamsRepository<StreamType : Any,FavType: Any,CategoryType : Any>(
    private val baseStreamDao: BaseRoomStreamsInterface<StreamType>,
    private val baseFavDao: RoomBaseInterface<FavType>,
    private val baseCategoryDao: RoomBaseInterface<CategoryType>
){

    suspend fun getTopTens() = baseStreamDao.recentlyAdded()

     fun recentlyAddedFlow(limit:Int = AllConst.ROOM_RECENT_QUERY_LIMIT) = baseStreamDao.recentlyAddedFlow(limit)


     fun getRecentlyAddedSize() = baseStreamDao.getRecentlyAddedSize()
    fun getStreamsAsFlow(categoryId:Int?=AllConst.ALL_CATEGORIES_ID.toInt(), nameQuery:String?="",limit: Int?=-1, offset: Int?=0) = baseStreamDao.allAsFlow(categoryId=categoryId,nameQuery=nameQuery, limit=limit, offset=offset)
    fun getStreams(categoryId:Int?=AllConst.ALL_CATEGORIES_ID.toInt(), nameQuery:String?="",limit: Int?=-1, offset: Int?=0) = baseStreamDao.allAsFlow(categoryId=categoryId,nameQuery=nameQuery, limit=limit, offset=offset)

    fun getStreamsAsPagingSource(categoryId: Int?,
                                 nameQuery: String?): PagingSource<Int, StreamType> = baseStreamDao.allAsPagingSource(categoryId,nameQuery)
    fun getStreamsAsPagingSource(
        categoryIds: List<Int>?,
        nameQuery: String?,
    ): PagingSource<Int, StreamType> = baseStreamDao.allAsPagingSource(categoryIds,nameQuery)

     fun getRecentlyAdded(limit: Int): Flow<PagingData<StreamType>> {
         return  Pager(
             config = PagingConfig(
                 pageSize = PAGING_PAGE_SIZE,
                 enablePlaceholders = false,

             ),

             pagingSourceFactory = {

                 baseStreamDao.getRecentlyAdded(limit)
             }
         ).flow
     }
    fun getRecentlyAddedFlowList(limit: Int): Flow<List<StreamType>> = baseStreamDao.getRecentlyAddedFlow(limit)
     fun getRecommendations(categoryId:Int?,limit: Int): PagingSource<Int, StreamType> = baseStreamDao.getRecommendations(categoryId,limit)
     /**
      * deletes all data and set new ones in transaction
      */
     @Transaction
   suspend fun refreshData(streams: List<StreamType>) {
        baseStreamDao.deleteAll()
         baseStreamDao.insert(streams)
    }

     /**
      * deletes all data and set new ones in transaction
      */
     @Transaction
    suspend fun refreshCategories(categories: List<CategoryType>) {
         baseCategoryDao.deleteAll()
         baseCategoryDao.insert(categories)
     }

    suspend fun insertStreams(streams: List<StreamType>) = baseStreamDao.insert(streams)
    suspend fun insertStream(stream: StreamType) = baseStreamDao.insert(stream)

    fun getFavoritesPagingSource(): PagingSource<Int, StreamType> = baseStreamDao.getPagedFavoriteStreams()
    fun getWatchedStreamsFlow(limit: Int?=null) = baseStreamDao.getWatchedStreamsFlow(limit)
    fun getPagedWatchedStreams(): PagingSource<Int, StreamType> = baseStreamDao.getPagedWatchedStreams()

    fun getFavoritesAsFlow(limit: Int?=-1) = baseStreamDao.getFavoriteStreamsFlow(limit)
    suspend fun getFavorites() = baseStreamDao.getFavoriteStreams()
    suspend fun streamsSize() = baseStreamDao.getSize()
    suspend fun streamsSize(id:Int?)= baseStreamDao.getSize(id)
     fun getSizeAsFlow(id:Int?)= baseStreamDao.getSizeAsFlow(id)
//favorites

    suspend fun insertFavorite(stream: FavType) = baseFavDao.insert(stream)
    suspend fun insertFavorites(streams: List<FavType>) = baseFavDao.insert(streams)
    suspend fun deleteFavorite(stream: FavType) = baseFavDao.delete(stream)
    suspend fun deleteFavorites(liveStream: List<FavType>) = baseFavDao.delete(liveStream)
     fun isFavoriteAsFlow(streamId: Int?): Flow<Boolean> = baseFavDao.hasEntityAsFlow(streamId)
    suspend fun isFavorite(streamId: Int): Boolean = baseFavDao.hasEntity(streamId)
    suspend fun favStreamsSize() = baseFavDao.getSize()
    //Live Categories
    fun getCategoriesAsFlow() = baseCategoryDao.allAsFlow()
    fun getCategoriesAsPagingFlow():PagingSource<Int, CategoryType> = baseCategoryDao.allAsPagingSource()

    val categoriesPagingFlow : Flow<PagingData<CategoryType>> = Pager(
        config = PagingConfig(
            pageSize = AllConst.PAGING_MIN_PAGE_SIZE,
            enablePlaceholders = false,
        ),
        pagingSourceFactory = {

            getCategoriesAsPagingFlow()
        }
    ).flow
   suspend fun insertCategories(liveCategories: List<CategoryType>) = baseCategoryDao.insert(liveCategories)


}
